<template>
    <v-layout justify-center>
    <v-card>
     <v-card-title class="head title-center" style="display:block; text-align:center;" >
<!--タイトル-->
学術集会向けオンライン演題登録/査読システム
<v-icon class="ml-2 mt-1" color="black">
        mdi-book-open-variant
</v-icon>
      </v-card-title>

    <!--概要-->
    <Summary></Summary>
    <!--登録システム-->
    <Registrationsystem></Registrationsystem>
    <!--査読システム-->
    <Reviewsystem></Reviewsystem>
    <achievement></achievement>
    <!--お問い合わせ-->
    <contact></contact>
    </v-card>
    </v-layout>
</template>

<style>
.title-center{
  justify-content: center;
}
</style>

<script>
import Summary from './Summary'
import Registrationsystem from './Registrationsystem'
import Reviewsystem from './Reviewsystem'
import achievement from './achievement'
import contact from '../contact'

export default {
  data () {
    return {
      // タイトル横のアイコン
      icon: 'mdi-book-open-variant',
      // タイトル
      title: ''
    }
  },
  components: {
    Summary,
    Registrationsystem,
    Reviewsystem,
    achievement,
    contact
  }
}
</script>
